import React from "react";
import { Button } from "react-bootstrap";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { IMPLEMENTED_TRIGGERS } from "./triggers";

const TriggerIntentModal = ({ open, onClose }) => (
  <Dialog sx={{ "& .MuiDialog-paper": { width: "85%" } }} maxWidth="md" open={open}>
    <DialogTitle>Trigger Reference</DialogTitle>
    <DialogContent dividers>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Trigger</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Fires</TableCell>
            <TableCell>Until</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {IMPLEMENTED_TRIGGERS.map((t) => (
            <TableRow key={t.value}>
              <TableCell>{t.value}</TableCell>
              <TableCell>{t.type}</TableCell>
              <TableCell>{t.fires}</TableCell>
              <TableCell>{t.until}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
);

export default TriggerIntentModal;
